import InfoIcon from "@mui/icons-material/InfoOutlined";
import IconButton, { type IconButtonProps } from "@mui/material/IconButton";
import Tooltip, { tooltipClasses, type TooltipProps } from "@mui/material/Tooltip";
import { alpha, styled } from "@mui/material/styles";

const InfoTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backdropFilter: "blur(10px) brightness(105%)",
    backgroundColor: alpha(theme.palette.background.paper, 0.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: "none",
    color: theme.palette.text.primary,
    fontSize: "0.75rem",
    lineHeight: 1.35,
    maxWidth: theme.spacing(42),
    padding: theme.spacing(1.25),
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: alpha(theme.palette.background.paper, 0.5),
    "&::before": {
      border: `1px solid ${theme.palette.divider}`,
    },
  },
}));

type ProposalInfoTooltipProps = {
  title: TooltipProps["title"];
  placement?: TooltipProps["placement"];
  edge?: IconButtonProps["edge"];
};

export default function ProposalInfoTooltip(props: Readonly<ProposalInfoTooltipProps>) {
  const { title, edge } = props;
  const placement = props.placement ?? "right";

  return (
    <InfoTooltip arrow disableFocusListener placement={placement} title={title}>
      <IconButton edge={edge} size="medium">
        <InfoIcon fontSize="medium" />
      </IconButton>
    </InfoTooltip>
  );
}
